module.exports = __webpack_public_path__ + "vfn-assets/img/logo-viva-fan-v-3.0b70a4e6.svg";